function AdminDashboard() {
  return (
    <>
      <h1>Admin dashboard</h1>
    </>
  );
}

export default AdminDashboard;
